export default __webpack_public_path__ + "static/juniper-38267c84ac06abd57a8c942d4e90eab5.jpg";